(function () {
    'use strict';

    angular
        .module('travelControllers', [
        ]);
})();
